import { useState } from 'react';
import { useSelector } from 'react-redux';
import useTranslation from '../../../hooks/useTranslations';

/** TODO: Refactor & make more readable
 * 
 * @param objectList a list of all objects to fetch and display tags for
 * @param onSelectCallback Callback which will be called, when a tag has been unselected
 *      Signature: function(string[] selectedTags) {...}
 * @param fieldMap An object specifying which fields of the objectList should
 *  			   be relevant for chips and their respective redux-store GetByIds-Getter
 * 				   fieldMap: { [key: string]: {fn: (array) => array, prefix: string}}
 * 						where key has to be equal to the field definition in the content response
 * @param reduxGetByIds a redux-store function to retrieve targets by their id
 */
const ChipFilterMultipleFields = ({ objectList, onSelectCallback, fieldMap = {}}) => {
	// Get occurences for each field
	const targetOccurencesNew = {};
	Object.values(objectList).forEach((object) => {
		Object.keys(fieldMap).forEach((field) => {
			if (!targetOccurencesNew[field]) targetOccurencesNew[field] = [];

			if (object[field]) { targetOccurencesNew[field] = targetOccurencesNew[field].concat([object[field]].flat()); }
		});
	});

	// Make occurances distinct
	Object.keys(targetOccurencesNew).forEach((key) => {
		targetOccurencesNew[key] = [...new Set(targetOccurencesNew[key])];
	});

	// Setup state and get elements from redux
	const [selectedTargets, setSelectedTargets] = useState(Object.keys(targetOccurencesNew).reduce((prev, key) => {
		const newPrev = prev;
		newPrev[key] = [];
		return newPrev;
	}, {}));
	const contentTargets = useSelector((state) => Object.entries(fieldMap).reduce((prev, [key, value]) => {
		const newPrev = prev;
		newPrev[key] = value.fn(state, targetOccurencesNew[key]);
		return newPrev;
	}, {}));
	const t = useTranslation(true);

	const onButtonClick = (key, target) => {
		const newState = selectedTargets;

		if (newState[key].includes(target)) newState[key] = newState[key].filter((el) => el !== target);
		else newState[key] = [...newState[key], target];

		setSelectedTargets({ ...newState });
		onSelectCallback({ ...newState });
	};

	if (contentTargets) {
		return (
			<div className="flex justify-center gap-[20px] mb-[10px] whitespace-nowrap flex-wrap">
				{
					Object
						.entries(contentTargets)
						.map(([key, values]) => (
							values
								? Object.values(values).sort(sortFn).map((el) => (
									<button
										onClick={() => onButtonClick(key, el.id)}
										key={`${key}${el.id}`}
										type="button"
										className="focus:outline-none p-[10px] rounded-[12px] border-[1px] border-[#285A82]"
										style={{
											backgroundColor: selectedTargets[key]?.includes(el.id) ? '#285A82' : 'transparent',
											color: selectedTargets[key]?.includes(el.id) ? '#FFF' : '#285A82',
										}}
									>
										{fieldMap[key].prefix ?? null}
										{ t(el.translationkey) }
									</button>
								))
								: null
						))
				}
			</div>
		);
	}

	return <></>;
};

const sortFn = ((a, b) => {
	if (a.position && b.position) {
		return a.position - b.position;
	}

	return 0;
});

export default ChipFilterMultipleFields;
